//Import React
import React, { useState } from "react";
import Select from 'react-select';
//Import Component
import BudgetTable from "./BudgetTable";
import PrintBudgetButton from "./PrintBudgetButton";
//Import Helpers
import { subsidyNames, getCurrentDate } from "../../../../shared/helpers";
//Import CSS
import './reportsBudget.css';

function ReportsBudget({ pme, onClose, yearSelected, establishmentList, pmeList, isAdmin, isHolder, userData, dataSearch }) {
    const [selectedSubsidy, setSelectedSubsidy] = useState({ value: 'all', label: 'Todas las subvenciones' });

    const subsidyOptions = [
        { value: 'all', label: 'Todas las subvenciones' },
        ...Object.entries(subsidyNames).map(([key, value]) => ({
            value: key,
            label: value
        }))
    ];

    return (
        <section className='reports-budget-container flex'>
            <header className='budget-header flex'>
                <h1>Ejecución Presupuestaria Año {yearSelected}</h1>
                <span className='header-actions flex'>
                    <PrintBudgetButton />
                    <button className='btn-close flex' onClick={() => onClose(false)}><p>Cerrar</p></button>
                </span>
            </header>
            <article className='budget-content flex'>
                <article className='budget-info flex'>
                    <span className='info flex'>
                        <p>Año:</p>
                        <p>{yearSelected}</p>
                    </span>
                    <span className='info flex'>
                        <label>Tipo de Subvención:</label>
                        <Select
                            defaultValue={{ value: 'all', label: 'Todas las subvenciones' }}
                            value={selectedSubsidy}
                            onChange={setSelectedSubsidy}
                            options={subsidyOptions}
                            className="custom-select"
                            classNamePrefix="custom-select"
                        />
                    </span>
                    <span className='info flex'>
                        <p>Fecha:</p>
                        <p>{getCurrentDate()}</p>
                    </span>
                </article>
                <section className='budget-table-container flex'>
                    <BudgetTable
                        pme={pme}
                        yearSelected={yearSelected}
                        selectedSubsidy={selectedSubsidy}
                        establishmentList={establishmentList}
                        pmeList={pmeList}
                        isAdmin={isAdmin}
                        isHolder={isHolder}
                        userData={userData}
                        dataSearch={dataSearch}
                    />
                </section>
            </article>
            <footer className='budget-footer'>
                <p>Informe generado el {getCurrentDate()}</p>
            </footer>

        </section>
    );
};

export default ReportsBudget;